/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef, useState,useEffect } from "react";
// import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick";
export default function DeviceDropdownwithsearch({
    label,
    id,
    placeholder,
    value,
    index,
    options,
    handleOnChangeInput,
    disabled,
    handleTemplateListSearch,
    emptyField,
    data_testid,
    filterScroll,
    obj,
    objKey,
    deviceTempateres,
    templateListSearch
}
) {
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null)
    const [displayEmptyMsg,setDisplayEmptyMsg] = useState('')
    const [isOpen, setisOpen] = useState(false);
    const [isOpentemplateDiv, setIsOpetemplateDiv] = useState(false);
    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });

    useEffect(() => {
        if (options!== undefined) {
            if (options?.length === 0) {
                setDisplayEmptyMsg('No results found.')
                return
            }
            setDisplayEmptyMsg('')
        } 
    },[options])

    useEffect(()=>{
        setDisplayEmptyMsg('')
        if(isOpen) {
            handleTemplateListSearch("")
        }
    },[isOpentemplateDiv])

    return (
        <>
            <div className='relative' ref={ref}>
                <p htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</p>
                <button  ref={buttonRef} data-testid="select-device-btn"  onClick={() => {setisOpen(!isOpen);setIsOpetemplateDiv(!isOpentemplateDiv) }} className={`border ${emptyField?'border-[#C81720]':'border-[#C5C9DA] '} rounded-lg px-3.5 py-[12px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`} disabled={disabled} >
                    <p id= {id}className={`${placeholder!=="Day(s)"&&(value === "" || value === undefined || value === true)?'text-[#52555D] ':'text-[#000B17] '}text-start text-sm`}>{(value === "" || value === undefined || value === true)
                        ? placeholder
                        : value}</p>
                   
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen?"transform rotate-180" : ""}`}/>
                </button>
                <ul className={`py-4 pl-4 pr-1 rounded-lg bg-white z-[999] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul>
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input
                                        type="text"
                                        autoComplete={"off"}
                                        id="search"
                                        placeholder="Search by template name"
                                        className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-2.5 w-full outline-none"
                                        value={templateListSearch.search||''}
                                        onChange={(e) => {handleTemplateListSearch(e.target.value)}}
                                        
                                    />
                                    <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3" />
                                </div>
                            </li>
                        </ul>
                        {(deviceTempateres.status==='pending') &&
                            <div className='flex justify-center items-center mb-[40px] mt-[90px]'>             
                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  mt-[-45px] spin-animation"></div>                                                     
                            </div>
                        }
                        {(deviceTempateres.status==='fulfilled')&&displayEmptyMsg === "" ?
                            <ul className={`max-h-[340px] overflow-auto  ${filterScroll ? 'scrollbar_gray' : 'scrollBar_green'} `}>
                           
                                {options?.map((option,i)=>(
                                    <li
                                        key={i}
                                        data-testid='device_template'
                                        id={id}
                                        onClick={(e) => {
                                            handleOnChangeInput(id, option,index),
                                            setisOpen(false);
                                        }} 
                                    >
                                        <p className={'w-full inline-block pl-4 mb-3 cursor-pointer text-sm font-normal text-[#000] hover:text-[#008586]'}>{option[objKey]}</p>
                                    </li>
                                ))}
                               
                            </ul>:
                            <p className="mt-2 text-center">{(deviceTempateres.status==='pending') ?'': displayEmptyMsg}</p>}
                        
                       
                    </li>
                </ul>             
            </div>
        </>
    )
}
